import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBookedFromDeveloperEnabled } from 'shared/selectors';
import { selectAsideCompactMode } from 'shared/selectors/aside';
import { selectFloorTitle } from 'shared/selectors/newbuilding';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';
import { selectOfferTitle } from 'shared/selectors/selectOfferTitle';

export function OfferTitleSidebarContainer() {
  const title = useSelector(selectOfferTitle);
  const isCompactModeEnabled = useSelector(selectAsideCompactMode);
  const floorTitle = useSelector(selectFloorTitle);
  const isBooked = useSelector(selectIsBookedFromDeveloper);
  const bookedFromDeveloperEnabled = useSelector(selectBookedFromDeveloperEnabled);

  const isBookedFromDeveloper = isBooked && bookedFromDeveloperEnabled;

  if (!isCompactModeEnabled) {
    return null;
  }

  return (
    <UIText1 data-testid="offer-title-sidebar" color={isBookedFromDeveloper ? 'text-secondary-default' : undefined}>
      {title}
      {floorTitle}
    </UIText1>
  );
}
